import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DownloadIcon from '@mui/icons-material/Download';
import { Box, Button, Chip, CircularProgress, Skeleton, Stack, Typography } from '@mui/material';
import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

interface InformeFinalEmitidoCardProps {
  fechaEmision: string | null;
  isFetching: boolean;
  onVerDescargar: () => void;
}

export function InformeFinalEmitidoCard({
  fechaEmision,
  isFetching,
  onVerDescargar,
}: InformeFinalEmitidoCardProps): JSX.Element {
  const fechaFormateada = fechaEmision
    ? format(parseISO(fechaEmision), 'dd/MM/yyyy HH:mm', { locale: es })
    : null;

  return (
    <Box
      sx={{
        bgcolor: 'grey.100',
        border: '0.5px solid',
        borderColor: 'success.main',
        borderRadius: 1,
        p: '14px',
        display: 'flex',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <CheckCircleOutlineIcon
        sx={{ fontSize: 28, color: 'success.main', flexShrink: 0 }}
      />

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Stack direction="row" alignItems="center" spacing={1} mb={0.5}>
          <Typography variant="subtitle2" fontWeight={600}>
            Informe final
          </Typography>
          <Chip
            label="Emitido"
            size="small"
            sx={{
              bgcolor: 'success.main',
              color: 'success.contrastText',
              height: 20,
              fontSize: 11,
            }}
          />
        </Stack>

        {fechaFormateada ? (
          <Typography variant="body2" color="text.secondary">
            Emitido el {fechaFormateada}
          </Typography>
        ) : isFetching ? (
          <Skeleton width={160} height={20} />
        ) : (
          <Typography variant="body2" color="text.secondary">
            —
          </Typography>
        )}
      </Box>

      <Button
        variant="outlined"
        size="small"
        disabled={isFetching}
        onClick={onVerDescargar}
        startIcon={
          isFetching && fechaFormateada ? (
            <CircularProgress size={16} color="inherit" />
          ) : (
            <DownloadIcon />
          )
        }
        sx={{ flexShrink: 0 }}
      >
        {isFetching && fechaFormateada ? 'Generando...' : 'Ver / descargar'}
      </Button>
    </Box>
  );
}
